import { useCallback } from "react";
import { fetchPublicPathway } from "./learnerApi";
import useMemberRead from "./useMemberRead";

/**
 * `GET /public/pathways/{id}`: one pathway's card detail and level outline, readable by
 * anyone (contract §5.2). `viewer_enrolled` is true only when a session is present AND has
 * joined.
 *
 * `viewer` is the signed-in e-mail ("" when anonymous). It is part of the read's identity
 * because `viewer_enrolled` depends on who is asking: a visitor who signs in on the page is
 * re-read, so an existing learner goes from the detail to the home with no reload.
 *
 * `notFound` covers an absent, draft or ARCHIVED pathway. An archived pathway stays readable
 * by its learners through the member read; the page decides that, not this hook.
 *
 * @param {string} id      pathway id from the route
 * @param {string} viewer  signed-in e-mail, or ""
 */
export default function usePublicPathway(id, viewer) {
  // `viewer` is deliberately a dependency although the request never sends it: the session
  // cookie does, and a change of session must re-run the read.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetcher = useCallback(() => fetchPublicPathway(id), [id, viewer]);
  return useMemberRead(fetcher);
}
